// component
import SvgColor from '../../../components/svg-color';
import Iconify from '../../../components/iconify/Iconify';
import { tokenService } from 'src/services';

// ----------------------------------------------------------------------

const icon = (name) => <Iconify icon={name} sx={{ width: 1, height: 1 }} />;

// const isUserAllowedForSafeBox = tokenService?.getUser()?.authLocations?.mall.some(x => x.id === "61973122632916808660");
// console.log(isUserAllowedForSafeBox);
const navConfig = [
  {
    title: 'İstatistikler',
    path: '/dashboard/app',
    icon: icon('wpf:statistics'),
    permissions: [
      'mall:manager:mall-administration',
      'mall-logistics:accounting:accountant',
      'mall-logistics:accountant:accountant',
      'mall-logistics:operations:highadmin',
      'mall-logistics:manager:highadmin',
      'mall-logistics:manager:porter',
      'mall-logistics:operations:admin',
      'mall-logistics:regional-manager:admin',
      'mall-logistics:manager:superadmin',
      'store:manager:corporational',
      'store:manageroperations:corporational',
      'store:operations:corporational',
      'mall:mall-administration:admin',
    ],
    category: 'Yönetim',
  },
  {
    title: 'Özet',
    path: '/dashboard/mall-management-statistics',
    icon: icon('eva:bar-chart-2-outline'),
    permissions: [
      'mall-logistics:mall-management-showcase:user',
      'mall-logistics:mall-management-statistics:user',
      'mall-logistics:mall-management:user',
    ],
    category: 'PANEL',
  },
  {
    title: 'Mal Kabul',
    path: '/dashboard/mall-management-goods-acceptance',
    icon: icon('mdi:truck-delivery-outline'),
    permissions: [
      'mall-logistics:mall-management-showcase:user',
      'mall-logistics:mall-management-goods-acceptance:user',
      'mall-logistics:mall-management:user',
    ],
    category: 'MALL LOGISTICS',
  },
  /*
  {
    title: 'Tanıtım Ekranı',
    path: '/dashboard/mall-management-preview',
    icon: icon('mdi:truck-delivery-outline'),
    permissions: [
      'mall-logistics:mall-management-showcase:user',
      'mall-logistics:mall-management:user',
    ],
    category: 'MALL LOGISTICS',
  },
  */

  {
    title: 'Muhaberat',
    path: '/dashboard/mall-management-correspondence',
    icon: icon('eva:person-done-outline'),
    permissions: [
      'mall-logistics:mall-management-showcase:user',
      'mall-logistics:mall-management-correspondence:user',
      'mall-logistics:mall-management:user',
    ],
    category: 'MALL LOGISTICS',
  },
  {
    title: 'Emanet Dolabı',
    path: '/dashboard/mall-management-safety-locker',
    icon: icon('mdi:locker-multiple'),
    permissions: [
      'mall-logistics:mall-management-showcase:user',
      'mall-logistics:mall-management-safety-locker:user',
      'mall-logistics:mall-management:user',
    ],
    category: 'EASY EMANET',
  },
  {
    title: 'Emanet - Vestiyer',
    path: '/dashboard/mall-management-safety-cloakroom',
    icon: icon('mdi:hanger'),
    permissions: [
      'mall-logistics:mall-management-showcase:user',
      'mall-logistics:mall-management-safety-cloakroom:user',
      'mall-logistics:mall-management:user',
    ],
    category: 'EASY EMANET',
  },

  {
    title: 'Click & Collect',
    path: '/dashboard/mall-management-click-collect',
    icon: icon('mdi:store-marker-outline'),
    permissions: [
      'mall-logistics:mall-management-showcase:user',
      'mall-logistics:mall-management-clickAndCollect:user',
      'mall-logistics:mall-management:user',
    ],
    category: 'EASY POINT',
  },

  {
    title: 'Kargo (DHL, Aras, Kargoist)',
    path: '/dashboard/mall-management-cargo',
    icon: icon('fluent:box-24-regular'),
    permissions: [
      'mall-logistics:mall-management-showcase:user',
      'mall-logistics:mall-management:user',
      'mall-logistics:mall-management-cargo:user',
    ],
    category: 'EASY POINT',
  },

  {
    title: 'Eve Teslimat',
    path: '/dashboard/mall-management-home-delivery',
    icon: icon('carbon:delivery'),
    permissions: [
      'mall-logistics:mall-management-showcase:user',
      'mall-logistics:mall-management-home-delivery:user',
      'mall-logistics:mall-management:user',
    ],
    category: 'EASY POINT',
  },

  {
    title: 'Tax Free',
    path: '/dashboard/mall-management-tax-free',
    icon: icon('mdi:receipt-outline'),
    permissions: [
      'mall-logistics:mall-management-showcase:user',
      'mall-logistics:mall-management-tax-free:user',
      'mall-logistics:mall-management:user',
    ],
    category: 'EASY POINT',
  },
  {
    title: 'Pet Arabası',
    path: '/dashboard/mall-management-pet-car',
    icon: icon('mdi:paw'),
    permissions: [
      'mall-logistics:mall-management-showcase:user',
      'mall-logistics:mall-management-pet-car:user',
      'mall-logistics:mall-management:user',
    ],
    category: 'EASY POINT',
  },
  {
    title: 'Çocuk Arabası',
    path: '/dashboard/mall-management-kid-car',
    icon: icon('mdi:stroller'),
    permissions: [
      'mall-logistics:mall-management-showcase:user',
      'mall-logistics:mall-management-kid-car:user',
      'mall-logistics:mall-management:user',
    ],
    category: 'EASY POINT',
  },
  {
    title: 'Handsfree',
    path: '/dashboard/mall-management-handsfree',
    icon: icon('eva:shopping-bag-outline'),
    permissions: [
      'mall-logistics:mall-management-showcase:user',
      'mall-logistics:mall-management-handsfree:user',
      'mall-logistics:mall-management:user',
    ],
    category: 'EASY POINT',
  },
  {
    title: 'PostBox',
    path: '/dashboard/mall-management-postbox',
    icon: icon('mdi:mailbox-outline'),
    permissions: [
      'mall-logistics:mall-management-showcase:user',
      'mall-logistics:mall-management-postbox:user',
      'mall-logistics:mall-management:user',
    ],
    category: 'EASY POINT',
  },
  /*
  {
    title: 'Easy Mall',
    path: '/dashboard/mall-management-easymall',
    icon: icon('icon-park-outline:sales-report'),
    permissions: [
      'mall-logistics:mall-management-showcase:user',
      'mall-logistics:mall-management:user',
    ],
    category: 'PANEL',
  },
  */
  {
    title: 'Hediye Paketi',
    path: '/dashboard/mall-management-gift',
    icon: icon('eva:gift-outline'),
    permissions: [
      'mall-logistics:mall-management-showcase:user',
      'mall-logistics:mall-management-gift:user',
      'mall-logistics:mall-management:user',
    ],
    category: 'EASY POINT',
  },
  {
    title: 'İşlemler',
    path: '/dashboard/finished-jobs',
    icon: icon('icon-park-outline:sales-report'),
    permissions: [
      'mall:manager:mall-administration',
      'mall-logistics:accounting:accountant:',
      'mall-logistics:accountant:accountant',
      'mall-logistics:operations:highadmin',
      'mall-logistics:operations:porter',
      'mall-logistics:mall-management:admin',
      'mall-logistics:manager:highadmin',
      'mall-logistics:manager:porter',
      'mall-logistics:operations:admin',
      'mall-logistics:regional-manager:admin',
      'mall-logistics:manager:superadmin',
      'store:manager:corporational',
      'store:manageroperations:corporational',
      'store:operations:corporational',
      'mall:mall-administration:admin',
      'company:company-manager:user',
    ],
    category: 'Yönetim',
  },
  {
    title: 'İşlem Detay',
    path: '/dashboard/finished-jobs-detail',
    hidden: true,
    permissions: [
      'mall:manager:mall-administration',
      'mall-logistics:accounting:accountant:',
      'mall-logistics:accountant:accountant',
      'mall-logistics:operations:highadmin',
      'mall-logistics:operations:porter',
      'mall-logistics:mall-management:admin',
      'mall-logistics:manager:highadmin',
      'mall-logistics:manager:porter',
      'mall-logistics:operations:admin',
      'mall-logistics:regional-manager:admin',
      'mall-logistics:manager:superadmin',
      'store:manager:corporational',
      'store:manageroperations:corporational',
      'store:operations:corporational',
      'mall:mall-administration:admin',
      'company:company-manager:user',
    ],
    category: 'Yönetim',
  },
  // {
  //   title: 'Canlı Operasyon Takibi',
  //   path: '/dashboard/live-operations-tracking',
  //   icon: icon('heroicons:signal-16-solid'), // Also could use -20
  //   permissions: [
  //     'mall-logistics:operations:highadmin',
  //     'mall-logistics:manager:highadmin',
  //     'mall-logistics:operations:admin',
  //     'mall-logistics:regional-manager:admin',
  //     'mall-logistics:manager:superadmin',
  //   ],
  //   category: 'Yönetim',
  // },
  // {
  //   title: 'Canlı Operasyon Takibi ',
  //   path: '/dashboard/live-operations-tracking-region-master',
  //   icon: icon('heroicons:signal-16-solid'), // Also could use -20
  //   permissions: [
  //     'mall-logistics:operations:highadmin',
  //     'mall-logistics:manager:highadmin',
  //     'mall-logistics:regional-manager:admin',
  //     'mall-logistics:manager:superadmin',
  //   ],
  //   category: 'Yönetim',
  // },
  {
    title: 'Mağaza Düzenle',
    path: '/dashboard/edit-store',
    hidden: true,
    permissions: [
      'mall-logistics:manager:highadmin',
      'mall-logistics:operations:highadmin',
      'mall-logistics:manageroperations:highadmin',
      'mall-logistics:accounting:accountant',
      'mall-logistics:accountant:accountant',
      'mall:manager:mall-administration',
      'mall:operations:mall-administration',
      'mall:manageroperations:mall-administration',
      'mall-logistics:manager:superadmin',
    ],
    category: 'Yönetim',
  },
  {
    title: 'Uyarı ve Blokaj Sistemi',
    path: '/dashboard/mall-alert-block-system',
    icon: icon('solar:shield-warning-outline'),
    permissions: [
      'mall-logistics:operations:highadmin',
      'mall-logistics:manager:highadmin',
      'mall-logistics:accounting:accountant',
      'mall-logistics:accountant:accountant',
    ],
    category: 'Yönetim',
  },
  {
    title: 'Uyarı ve Blokaj Kayıtları',
    path: '/dashboard/mall-alert-block-records',
    icon: icon('solar:document-text-outline'),
    permissions: [
      'mall-logistics:operations:highadmin',
      'mall-logistics:manager:highadmin',
      'mall-logistics:accounting:accountant',
      'mall-logistics:accountant:accountant',
    ],
    category: 'Yönetim',
  },
  // {
  //   title: 'Faturalar',
  //   path: '/dashboard/receipt-operations',
  //   icon: icon('ion:receipt-outline'),
  //   permissions: [
  //     'mall:manager:mall-administration',
  //     'mall-logistics:accounting:accountant',
  //     'mall-logistics:operations:highadmin',
  //     'mall-logistics:manager:highadmin',
  //     'mall-logistics:manager:porter',
  //     'mall-logistics:operations:admin',
  //     'mall-logistics:manager:superadmin',
  //     'store:manager:corporational',
  //     'store:manageroperations:corporational',
  //     'store:operations:corporational',
  //     'mall:mall-administration:admin',
  //   ],
  //   category: 'Yönetim',
  // },
  {
    title: 'İrsaliye Raporu',
    path: '/dashboard/handshakes-report-list',
    icon: icon('icon-park-outline:sales-report'),
    permissions: [
      // 'mall-logistics:manager:highadmin',
      'mall-logistics:manager:superadmin',
      'mall-logistics:handshakes:highadmin',
      'mall-logistics:accountant:accountant',
      'mall-logistics:manager:highadmin',
      'mall-logistics:operations:highadmin',
      'mall-logistics:manager:admin',
      'mall-logistics:regional-manager:admin',
      'store:manager:corporational',
      'store:manageroperations:corporational',
      'mall-logistics:manager:porter',
      'mall-logistics:mall-management:user',
    ],
    category: 'Yönetim',
  },
  {
    title: 'İrsaliye Detay',
    path: '/dashboard/handshake-detail',
    hidden: true,
    permissions: [
      'mall-logistics:manager:superadmin',
      'mall-logistics:handshakes:highadmin',
      'mall-logistics:accountant:accountant',
      'mall-logistics:manager:highadmin',
      'mall-logistics:operations:highadmin',
      'mall-logistics:manager:admin',
      'mall-logistics:regional-manager:admin',
      'store:manager:corporational',
      'store:manageroperations:corporational',
      'mall-logistics:manager:porter',
      'mall-logistics:mall-management:user',
    ],
    category: 'Yönetim',
  },
  {
    title: 'Telefon Talep Listesi',
    path: '/dashboard/post-task-checklist',
    icon: icon('icon-park-outline:sales-report'),
    permissions: [
      // 'mall-logistics:manager:highadmin',
      'mall-logistics:operations:admin',
      'mall-logistics:operations:highadmin',
      'mall-logistics:operations:superadmin',
      'mall-logistics:manager:admin',
      'mall-logistics:regional-manager:admin',
      'mall-logistics:manager:highadmin',
      'mall-logistics:manager:superadmin',
      'mall-logistics:manager:user',
      'mall-logistics:manager:porter',
    ],
    category: 'Yönetim',
  },
  // {
  //   title: 'Emanet Dolap Raporu',
  //   path: '/dashboard/safe-box-report',
  //   icon: icon('icon-park-outline:sales-report'),
  //   permissions: [
  //     'mall-logistics:manager:highadmin',
  //     'mall-logistics:manager:superadmin',
  //     'mall-logistics:operations:highadmin',
  //     'mall-logistics:operations:superadmin',
  //     'mall-logistics:mall-management:user'
  //   ],
  // },
  {
    title: 'Dolap İşlemleri',
    path: '/dashboard/safe-box-operations',
    icon: icon('icon-park-outline:sales-report'),
    permissions: [
      'mall-logistics:manager:highadmin',
      'mall-logistics:manager:superadmin',
      'mall-logistics:accountant:accountant',
      'mall-logistics:operations:highadmin',
      'mall-logistics:operations:superadmin',
    ],
    category: 'Emanet İşlemleri',
    accordion: 'Emanet İşlemleri',
  },
  {
    title: 'Vestiyer İşlemleri',
    path: '/dashboard/checkroom',
    icon: icon('icon-park-outline:sales-report'),
    permissions: [
      'mall-logistics:manager:highadmin',
      'mall-logistics:manager:superadmin',
      'mall-logistics:operations:highadmin',
      'mall-logistics:accountant:accountant',
      'mall-logistics:operations:superadmin',
    ],
    category: 'Emanet İşlemleri',
    accordion: 'Emanet İşlemleri',
  },
  {
    title: 'Tahsilat İşlemleri',
    path: '/dashboard/collection-transactions',
    icon: icon('icon-park-outline:sales-report'),
    permissions: [
      'mall-logistics:manager:highadmin',
      'mall-logistics:manager:superadmin',
      'mall-logistics:operations:highadmin',
      'mall-logistics:regional-manager:admin',
      'mall-logistics:manager:admin',
      'mall-logistics:operations:admin',
      'mall-logistics:operations:superadmin',
      'mall-logistics:accountant:accountant',
      'mall-logistics:manager:porter',
    ],
  },
  /*
  {
    title: 'Mesai Giriş - Çıkış Sistemi ( Takım Lideri )',
    path: '/dashboard/shift-checkin-out-team-leader',
    icon: icon('icon-park-outline:sales-report'),
    permissions: [
      'mall-logistics:manager:highadmin',
      'mall-logistics:manager:superadmin',
      'mall-logistics:operations:highadmin',
      'mall-logistics:regional-manager:admin',
      'mall-logistics:manager:admin',
      'mall-logistics:operations:admin',
      'mall-logistics:operations:superadmin',
      'mall-logistics:accountant:accountant',
      'mall-logistics:manager:porter',
    ],
  },
  {
    title: 'Mesai Giriş - Çıkış Sistemi ( Bölge Yöneticisi )',
    path: '/dashboard/shift-checkin-out-region-manager',
    icon: icon('icon-park-outline:sales-report'),
    permissions: [
      'mall-logistics:manager:highadmin',
      'mall-logistics:manager:superadmin',
      'mall-logistics:operations:highadmin',
      'mall-logistics:regional-manager:admin',
      'mall-logistics:manager:admin',
      'mall-logistics:operations:admin',
      'mall-logistics:operations:superadmin',
      'mall-logistics:accountant:accountant',
      'mall-logistics:manager:porter',
    ],
  },
  {
    title: 'Mesai Giriş - Çıkış Sistemi ( High Admin )',
    path: '/dashboard/shift-checkin-out-high-admin',
    icon: icon('icon-park-outline:sales-report'),
    permissions: [
      'mall-logistics:manager:highadmin',
      'mall-logistics:manager:superadmin',
      'mall-logistics:operations:highadmin',
      'mall-logistics:regional-manager:admin',
      'mall-logistics:manager:admin',
      'mall-logistics:operations:admin',
      'mall-logistics:operations:superadmin',
      'mall-logistics:accountant:accountant',
      'mall-logistics:manager:porter',
    ],
  },
  */
  // {
  //   title: 'Kargo - Kurye (Mağaza)',
  //   path: '/dashboard/cargo-courier',
  //   icon: icon('cil:truck'),
  //   permissions: [
  //     'mall-logistics:operations:highadmin',
  //     'mall-logistics:manager:highadmin',
  //   ],
  //   category: 'Yönetim',
  // },
  // {
  //   title: 'Kargo - Kurye (Yönetici)',
  //   path: '/dashboard/cargo-courier/master',
  //   icon: icon('cil:truck'),
  //   permissions: [
  //     'mall-logistics:operations:highadmin',
  //     'mall-logistics:manager:highadmin',
  //   ],
  //   category: 'Yönetim',
  // },
  // {
  //   title: 'Kargo - Kurye (AVM)',
  //   path: '/dashboard/cargo-courier/avm',
  //   icon: icon('cil:truck'),
  //   permissions: [
  //     'mall-logistics:operations:highadmin',
  //     'mall-logistics:manager:highadmin',
  //   ],
  //   category: 'Yönetim',
  // },
  // {
  //   title: 'Kargo - Kurye Cari Ekranı',
  //   path: '/dashboard/cargo-courier-order-report',
  //   icon: icon('cil:truck'),
  //   permissions: [
  //     'mall-logistics:operations:highadmin',
  //     'mall-logistics:manager:highadmin',
  //   ],
  //   category: 'Yönetim',
  // },

  {
    title: 'Yetki Talep Et',
    path: '/dashboard/request-permission',
    icon: icon('tabler:user-shield'),
    permissions: ['store:operations:corporational'],
    // Yöneticiler zaten yetkili; kontrol render anında yapılır
    hiddenForFrontAuth: ['manager'],
    category: 'Yönetim',
  },
  // ------------------------------------------

  {
    title: 'Dolap İşlemleri',
    path: '/dashboard/safe-box-operations-sample',
    icon: icon('icon-park-outline:sales-report'),
    permissions: ['mall-logistics:mall-management-showcase:user'],
    category: 'Emanet İşlemleri ',
    accordion: 'Emanet İşlemleri',
  },

  // {
  //   title: 'Hands Free',
  //   path: '/dashboard/handsfree-sample',
  //   icon: icon('icon-park-outline:sales-report'),
  //   permissions: ['mall-logistics:mall-management-showcase:user'],
  // },
  // {
  //   title: 'Faturalar',
  //   path: '/dashboard/finished-jobs',
  //   icon: icon('icon-park-outline:sales-report'),
  //   permissions: [
  //     'mall-logistics:accounting',
  //     'mall-logistics:manager',
  //     'store:manager',
  //     'store:manageroperations',
  //   ],
  // },
  // {
  //   title: 'Fiyat Listeleri',
  //   path: '/dashboard/finished-jobs',
  //   icon: icon('icon-park-outline:sales-report'),
  //   permissions: ['mall-logistics:accounting', 'mall-logistics:manager'],
  // },

  // {
  //   title: 'Hediye Kartı ile Ödeme Al',
  //   path: '/dashboard/loyalty-gift-card-payment',
  //   icon: icon('mdi:credit-card-check-outline'),
  //   permissions: [
  //     'store:operations:corporational',
  //     'mall-logistics:manager:highadmin',
  //   ],
  //   category: 'Loyalty Sistemi',
  // },
  // {
  //   title: 'Hediye Kartı Oluştur',
  //   path: '/dashboard/loyalty-gift-card-create',
  //   icon: icon('mdi:card-plus-outline'),
  //   permissions: [
  //     'store:operations:corporational',
  //     'mall-logistics:manager:highadmin',
  //   ],
  //   category: 'Loyalty Sistemi',
  // },
  // {
  //   title: 'Ayarlar',
  //   path: '/dashboard/loyalty-settings',
  //   icon: icon('eva:settings-2-outline'),
  //   permissions: [
  //     'store:operations:corporational',
  //     'mall-logistics:manager:highadmin',
  //   ],
  //   category: 'Loyalty Sistemi',
  // },

  // {
  //   title: 'Puan İstatistikleri',
  //   path: '/dashboard/mall-management-loyalty-statistics',
  //   icon: icon('mdi:chart-line'),
  //   permissions: [
  //     'mall-logistics:manager:highadmin',
  //     'mall:manager:mall-administration',
  //   ],
  //   category: 'Loyalty Sistemi',
  // },
  // {
  //   title: 'Puan Onay Sistemi',
  //   path: '/dashboard/mall-management-loyalty-approval',
  //   icon: icon('mdi:clipboard-check-outline'),
  //   permissions: [
  //     'mall-logistics:manager:highadmin',
  //     'mall:manager:mall-administration',
  //   ],
  //   category: 'Loyalty Sistemi',
  // },
  // {
  //   title: 'Hediye Kartlar',
  //   path: '/dashboard/mall-management-loyalty-gift-cards',
  //   icon: icon('mdi:wallet-giftcard'),
  //   permissions: [
  //     'mall-logistics:manager:highadmin',
  //     'mall:manager:mall-administration',
  //   ],
  //   category: 'Loyalty Sistemi',
  // },
  // {
  //   title: 'Puan Müşteri Listesi',
  //   path: '/dashboard/mall-management-loyalty-members',
  //   icon: icon('mdi:account-group-outline'),
  //   permissions: [
  //     'mall-logistics:manager:highadmin',
  //     'mall:manager:mall-administration',
  //   ],
  //   category: 'Loyalty Sistemi',
  // },
  // {
  //   title: 'Puan Ayarları',
  //   path: '/dashboard/mall-management-loyalty-settings',
  //   icon: icon('eva:settings-2-outline'),
  //   permissions: [
  //     'mall-logistics:manager:highadmin',
  //     'mall:manager:mall-administration',
  //   ],
  //   category: 'Loyalty Sistemi',
  // },

  {
    title: 'Fatura Ödeme Listesi',
    path: '/dashboard/invoice-payment-list',
    icon: icon('solar:bill-list-outline'),
    permissions: [
      'mall-logistics:manager:highadmin',
      'mall-logistics:accountant:accountant',
      'mall-logistics:manager:superadmin',
    ],
    category: 'Listeler',
  },
  {
    title: 'Porter Listesi',
    path: '/dashboard/porters',
    icon: icon('solar:bill-list-outline'),
    permissions: [
      'mall-logistics:hr:human-resource',
      'mall-logistics:accounting:human-resource',
      'mall-logistics:manager:highadmin',
      'mall-logistics:regional-manager:admin',
      'mall-logistics:manager:superadmin',
    ],
    category: 'Listeler',
  },
  // {
  //   title: 'Mağaza İzinleri',
  //   path: '/dashboard/store-authorizations',
  //   icon: icon('solar:bill-list-outline'),
  //   permissions: [
  //     'mall-logistics:manager:highadmin',
  //     'mall-logistics:regional-manager:admin',
  //     'mall-logistics:manager:superadmin',
  //   ],
  //   category: 'Listeler',
  // },
  {
    title: 'Mağaza İzinleri',
    path: '/dashboard/store-authorizations-v2',
    icon: icon('solar:bill-list-outline'),
    permissions: [
      'mall-logistics:manager:highadmin',
      'mall-logistics:regional-manager:admin',
      'mall-logistics:manager:superadmin',
      'mall-logistics:manager:porter',
    ],

    category: 'Listeler',
  },
  // {
  //   title: 'AVM-Porter Eşleştirme',
  //   path: '/dashboard/finished-jobs',
  //   icon: icon('icon-park-outline:sales-report'),
  //   permissions: ['mall-logistics:hraccounting', 'mall-logistics:manager','mall-logistics:manager:superadmin'],
  // },
  // {
  //   title: 'Depo Oluşturma',
  //   path: '/dashboard/finished-jobs',
  //   icon: icon('icon-park-outline:sales-report'),
  //   permissions: ['store:manageroperations'],
  // },
  // {
  //   title: 'Kullanıcı Oluşturma',
  //   path: '/dashboard/users',
  //   icon: icon('icon-park-outline:sales-report'),
  //   permissions: ['store:manageroperations'],
  // },
  // {
  //   title: 'Vestiyer',
  //   path: '/dashboard/finished-jobs',
  //   icon: icon('icon-park-outline:sales-report'),
  //   permissions: ['mall:manager'],
  // },
  // {
  //   title: 'Emanet',
  //   path: '/dashboard/finished-jobs',
  //   icon: icon('icon-park-outline:sales-report'),
  //   permissions: ['mall:manager'],
  // },

  // {
  //   title: 'Kişisel Paketlerim',
  //   path: '/dashboard/personal-packages',
  //   icon: icon('ph:package-light'),
  //   permissions: [
  //     'mall-logistics:manager:highadmin',
  //     'mall-logistics:accounting:accountant',
  //     'mall-logistics:accountant:accountant',
  //     'mall-logistics:manager:superadmin',
  //     'mall-logistics:regional-manager:admin',
  //     'mall-logistics:operations:porter',
  //     'mall-logistics:manager:porter',
  //   ],
  //   category: 'Kişisel Paket Ayarları',
  // },

  {
    title: 'Muhaberat Giriş',
    path: '/dashboard/muhaberat-entry',
    icon: icon('icon-park-outline:sales-report'),
    permissions: [
      'mall-logistics:manager:highadmin',
      'mall-logistics:operations:highadmin',
      'mall-logistics:manageroperations:highadmin',
      'mall-logistics:operations:muhaberat',
      'mall-logistics:manager:superadmin',
    ],
    category: 'Muhaberat',
  },
  {
    title: 'Muhaberat Çıkış',
    path: '/dashboard/muhaberat-output',
    icon: icon('icon-park-outline:sales-report'),
    permissions: [
      'mall-logistics:manager:highadmin',
      'mall-logistics:operations:highadmin',
      'mall-logistics:manageroperations:highadmin',
      'mall-logistics:operations:muhaberat',
      'mall-logistics:manager:superadmin',
      // 'mall-logistics:mall-management:user'
      'mall-logistics:exceptional:user',
    ],
    activeList: [
      '/dashboard/muhaberat-output',
      '/dashboard/muhaberat-output-users',
    ],
    category: 'Muhaberat',
  },
  {
    title: 'Mal Kabul Dosyası Giriş',
    path: '/dashboard/manuel-handshake',
    icon: icon('icon-park-outline:sales-report'),
    permissions: [
      'mall-logistics:manager:highadmin',
      'mall-logistics:operations:highadmin',
      'mall-logistics:manageroperations:highadmin',
      'mall-logistics:manager:porter',
      'mall-logistics:regional-manager:admin',
      'mall-logistics:manager:superadmin',
    ],
    category: 'Mal Kabul',
  },
  {
    title: 'Mal Kabul Dosyası Listesi',
    path: '/dashboard/manuel-handshake-list',
    icon: icon('solar:bill-list-outline'),
    permissions: [
      'mall-logistics:manager:highadmin',
      'mall-logistics:operations:highadmin',
      'mall-logistics:manageroperations:highadmin',
      'mall-logistics:manager:porter',
      'mall-logistics:regional-manager:admin',
      'mall-logistics:manager:admin',
      'mall-logistics:operations:admin',
      'mall-logistics:manager:superadmin',
      'company:company-manager:user',
    ],
    category: 'Mal Kabul',
  },
  {
    title: 'Onay Bekleyen İrsaliyeler',
    path: '/dashboard/pre-handshake-list',
    icon: icon('solar:bill-list-outline'),
    permissions: [
      'mall-logistics:manager:highadmin',
      'mall-logistics:manager:porter',
      'mall-logistics:regional-manager:admin',
      'mall-logistics:manager:superadmin',
    ],
    category: 'Listeler',
  },
  {
    title: (() => {
      if (tokenService?.getUser()?.accountCategory !== 'store')
        return 'Hands Free';
      const branchID = localStorage.getItem('branchID');
      const branches = tokenService?.getUser()?.authLocations?.branch ?? [];
      const branch =
        branches.find((b) => b.branchID === branchID) ?? branches[0];
      return branch?.mallID === '98569271082166328155'
        ? 'Bags-Free'
        : 'Hands Free';
    })(),
    path: '/dashboard/handsfree',
    icon: icon('icon-park-outline:sales-report'),
    permissions: [
      'store:manager:corporational',
      'store:manageroperations:corporational',
      'store:operations:corporational',
    ],
  },

  {
    title: 'Hands Free Yönetimi',
    path: '/dashboard/handsfree-management',
    icon: icon('icon-park-outline:sales-report'),
    permissions: ['store:handsfree-management:corporational'],
  },
  {
    title: 'Tüm İşlemler',
    path: '/dashboard/all-actions',
    icon: icon('icon-park-outline:sales-report'),
    permissions: [
      'mall:manager:mall-administration',
      'mall-logistics:manager:superadmin',
    ],
  },
  // {
  //   title: 'Easy Mall',
  //   path: '/dashboard/easy-mall',
  //   icon: icon('solar:bill-list-outline'),
  //   permissions: [
  //     'mall-logistics:manager:superadmin',
  //     'mall-logistics:operations:highadmin',
  //     'mall-logistics:manager:highadmin',
  //     'store:easy-mall:corporational',
  //   ],
  //   // permissionCombination: ['easy-mall', 'store-manager'],
  //   category: 'Easy Mall',
  // },
  {
    title: 'Easy Mall Listesi',
    path: '/dashboard/easy-mall-list',
    icon: icon('solar:bill-list-outline'),
    permissions: [
      'mall-logistics:manager:superadmin',
      'mall-logistics:manager:highadmin',
    ],
    permissionCombination: ['easy-mall', 'store-manager'],
    category: 'Easy Mall',
  },
  {
    title: 'Ürün Ekle',
    path: '/dashboard/easy-mall-product-add',
    icon: icon('solar:bill-list-outline'),
    permissions: [
      'mall-logistics:manager:superadmin',
      'mall-logistics:manager:highadmin',
    ],
    permissionCombination: ['easy-mall', 'store-manager'],
    category: 'Easy Mall',
  },
  // {
  //   title: 'Siparişler',
  //   path: '/dashboard/easy-mall-orders',
  //   icon: icon('solar:bill-list-outline'),
  //   permissions: [
  //     'mall-logistics:manager:superadmin',
  //     'mall-logistics:manager:highadmin',
  //   ],
  //   permissionCombination: ['easy-mall', 'store-manager'],
  //   category: 'Easy Mall',
  // },
  {
    title: 'Robot Listeleri',
    path: '/dashboard/robot-lists',
    icon: icon('icon-park-outline:sales-report'),
    permissions: [
      'mall-logistics:robot:highadmin',
      'mall-logistics:robot:porter',
      'mall-logistics:manager:superadmin',
    ],
    category: 'Robot',
  },
  {
    title: 'Robot İşlemleri',
    path: '/dashboard/robot-actions',
    icon: icon('icon-park-outline:sales-report'),
    permissions: [
      'mall-logistics:robot:highadmin',
      'mall-logistics:robot:porter',
      'mall-logistics:manager:superadmin',
    ],
    category: 'Robot',
  },
  // {
  //   title: 'Emanet Dolap Raporu',
  //   path: '/dashboard/monthly-prices',
  //   icon: icon('icon-park-outline:sales-report'),
  //   permissions: ['mall-logistics:manager:highadmin','mall-logistics:manager:superadmin'],
  // },
  // {
  //   title: 'Emanet Dolap Raporu (Yeni)',
  //   path: '/dashboard/monthly-cabine',
  //   icon: icon('icon-park-outline:sales-report'),
  //   permissions: ['mall-logistics:manager:highadmin','mall-logistics:manager:superadmin'],
  // },
  // {
  //   title: 'Teknik Destek Talepleri',
  //   path: '/dashboard/technical-support-requests',
  //   icon: icon('icon-park-outline:sales-report'),
  //   //permissions need to be set
  //   permissions: ['mall-logistics:accounting', 'mall-logistics:manager','mall-logistics:manager:superadmin'],
  // },
  // {
  //   title: 'Çalışan Oluşturma Onayı',
  //   path: '/dashboard/create-employee-approval',
  //   icon: icon('icon-park-outline:sales-report'),
  //   //permissions need to be set
  //   permissions: [
  //     'mall-logistics:robot',
  //     'mall-logistics:accounting',
  //     'mall-logistics:manager',
  //     'mall-logistics:operations',
  // 'mall-logistics:manager:superadmin',
  //   ],
  // },
  // {
  //   title: 'Müşteri Kayıt Etme Formu',
  //   path: '/dashboard/new-page',
  //   icon: icon('icon-park-outline:sales-report'),
  //   //permissions need to be set
  //   permissions: [
  //     'mall-logistics:robot',
  //     'mall-logistics:accounting',
  //     'mall-logistics:manager',
  //     'mall-logistics:operations',
  // 'mall-logistics:manager:superadmin',
  //   ],
  // },
  {
    title: 'AVM Mağaza Aktarımı',
    path: '/dashboard/fetch-branches',
    icon: icon('tabler:transfer'),
    permissions: [
      'mall-logistics:manager:highadmin',
      'mall-logistics:accounting:accountant',
      'mall-logistics:accountant:accountant',
      'mall-logistics:manager:superadmin',
    ],
    category: 'TEKNİK İŞLEMLER',
  },
  {
    title: 'AVM Listesi',
    path: '/dashboard/avm-list',
    icon: icon('solar:bill-list-outline'),
    permissions: [
      'mall-logistics:manager:highadmin',
      'mall-logistics:operations:highadmin',
      'mall-logistics:manageroperations:highadmin',
      'mall-logistics:accountant:accountant',
      'mall:manager:mall-administration',
      'mall:operations:mall-administration',
      'mall:manageroperations:mall-administration',
      'mall-logistics:manager:superadmin',
    ],
    category: 'Listeler',
  },
  {
    title: 'AVM Yönetim Yetkileri',
    path: '/dashboard/avm-permissions-management',
    icon: icon('mdi:shield-account-outline'),
    permissions: [
      'mall-logistics:manager:highadmin',
      'mall-logistics:operations:highadmin',
      'mall-logistics:manageroperations:highadmin',
      'mall-logistics:accountant:accountant',
      'mall:manager:mall-administration',
      'mall:operations:mall-administration',
      'mall:manageroperations:mall-administration',
      'mall-logistics:manager:superadmin',
    ],
    category: 'Listeler',
  },
  {
    title: 'Mağaza Listesi',
    path: '/dashboard/store-list',
    icon: icon('solar:bill-list-outline'),
    permissions: [
      'mall-logistics:manager:highadmin',
      'mall-logistics:operations:highadmin',
      'mall-logistics:manageroperations:highadmin',
      'mall-logistics:accounting:accountant',
      'mall-logistics:accountant:accountant',
      'mall:manager:mall-administration',
      'mall:operations:mall-administration',
      'mall:manageroperations:mall-administration',
      'mall-logistics:manager:superadmin',
    ],
    category: 'Listeler',
  },
  {
    title: 'Blokajlı Mağaza Listesi',
    path: '/dashboard/blocked-store-list',
    icon: icon('solar:lock-outline'),
    hiddenForAccountCategory: 'store',
    category: 'Listeler',
  },
  // {
  //   title: 'Avm Listesi',
  //   path: '/dashboard/avm-list',
  //   icon: icon('icon-park-outline:sales-report'),
  //   permissions: [
  //     'mall-logistics:manager',
  //     'mall-logistics:operations',
  //     'mall-logistics:manageroperations',
  // 'mall-logistics:manager:superadmin:',
  //     'mall:manager',
  //     'mall:operations',
  //     'mall:manageroperations',
  //   ],
  // },
  {
    title: 'Kullanıcılar',
    path: '/dashboard/users',
    icon: icon('ph:users-three-light'),
    permissions: [
      'mall-logistics:manager:highadmin',
      'mall-logistics:accounting:accountant',
      'mall-logistics:manager:superadmin',
      'mall-logistics:regional-manager:admin',
    ],
    category: 'TEKNİK İŞLEMLER',
  },
  {
    title: 'Noktalar',
    path: '/dashboard/points',
    icon: icon('ph:map-pin-bold'),
    permissions: [
      'mall-logistics:manager:highadmin',
      'mall-logistics:accounting:accountant',
      'mall-logistics:accountant:accountant',
      'mall-logistics:manager:superadmin',
      'mall-logistics:regional-manager:admin',
      'mall-logistics:operations:porter',
      'mall-logistics:manager:porter',
    ],
    category: 'Listeler',
  },
  // {
  //   title: 'Sözleşme İşlemleri',
  //   path: '/dashboard/contract-operations',
  //   icon: icon('mdi:file-document-outline'),
  //   permissions: [
  //     'mall-logistics:accounting:accountant',
  //     'mall-logistics:accountant:accountant',
  //     'mall-logistics:manager:highadmin',
  //     'mall-logistics:operations:highadmin',
  //     'mall-logistics:manager:superadmin',
  //     'mall-logistics:operations:superadmin',
  //   ],
  //   category: 'Listeler',
  // },
  {
    title: 'Cari Bilgiler',
    path: '/dashboard/corporate-list',
    icon: icon('icon-park-outline:sales-report'),
    permissions: [
      'mall-logistics:manager:highadmin',
      'mall-logistics:accounting:accountant',
      'mall-logistics:accountant:accountant',
      'mall-logistics:manager:superadmin',
    ],
    category: 'Listeler',
  },

  {
    title: 'QR İşlemleri',
    path: '/dashboard/qr',
    icon: icon('icomoon-free:qrcode'),
    permissions: [
      'mall-logistics:manager:highadmin',
      'mall-logistics:operations:highadmin',
      'mall-logistics:manager:superadmin',
      'mall-logistics:regional-manager:admin',
    ],
    category: 'TEKNİK İŞLEMLER',
  },
  {
    title: 'Mağaza QR Kodu',
    path: '/dashboard/store-qr',
    icon: icon('icon-park-outline:sales-report'),
    permissions: [
      'store:manager:corporational',
      'store:operations:corporational',
    ],
    category: 'TEKNİK İŞLEMLER',
  },
  {
    title: 'Rapor Oluştur',
    path: '/dashboard/create-report',
    icon: icon('carbon:report-data'),
    permissions: [
      'mall:manager:mall-administration',
      'mall-logistics:manager:superadmin',
      'mall-logistics:accounting:accountant:',
      'mall-logistics:operations:highadmin',
      'mall-logistics:manager:highadmin',
      'mall-logistics:operations:admin',
      // 'mall-logistics:operations:porter',
      // 'mall-logistics:manager:porter',
    ],
    category: 'TEKNİK İŞLEMLER',
  },
  {
    title: 'Kampanyalar',
    path: '/dashboard/campaign',
    icon: icon('mdi:hand-coin-outline'),
    permissions: [
      'mall-logistics:manager:highadmin',
      'mall-logistics:operations:highadmin',
      'mall-logistics:manager:superadmin',
    ],
    category: 'TEKNİK İŞLEMLER',
  },
  {
    title: 'Destek Talepleri',
    path: '/dashboard/support-tickets',
    icon: icon('hugeicons:customer-support'),
    permissions: [
      'mall:manager:mall-administration',
      'mall-logistics:manager:superadmin',
      'mall-logistics:hr:human-resource',
      'mall-logistics:accounting:accountant:',
      'mall-logistics:operations:highadmin',
      'mall-logistics:operations:porter',
      'mall-logistics:manager:highadmin',
      'mall-logistics:manager:porter',
      'mall-logistics:operations:admin',
      'mall-logistics:regional-manager:admin',
      'store:manager:corporational',
      'store:manageroperations:corporational',
      'store:operations:corporational',
      'store:technical-support-staff:corporational',
      'store:technical-support-manager:corporational',
      'mall-logistics:technical-support-staff:admin',
      'mall-logistics:technical-support-manager:admin',
      'mall-logistics:technical-support-staff:highadmin',
      'mall-logistics:technical-support-manager:highadmin',
      'mall-logistics:manageroperations:highadmin',
      'mall-logistics:operations:muhaberat',
      'mall-logistics:mall-management:user',
      'mall-logistics:exceptional:user',
      'mall-logistics:mall-management-showcase:user',
      'mall-logistics:mall-management-technical-support:user',
    ],
    category: 'TEKNİK İŞLEMLER',
  },
  {
    title: 'Kullanıcı İşlemleri',
    path: '/dashboard/mall-management-user-authorization',
    icon: icon('icon-park-outline:sales-report'),
    permissions: [
      'mall-logistics:mall-management-showcase:user',
      'mall-logistics:mall-management:user',
      'mall-logistics:manager:superadmin',
    ],
    category: 'TEKNİK İŞLEMLER',
  },
  {
    title: 'Log Arama',
    path: '/dashboard/log-search',
    icon: icon('et:search'),
    permissions: [
      'mall-logistics:manager:highadmin',
      'mall-logistics:manager:superadmin',
      'mall-logistics:operations:highadmin',
      'mall-logistics:operations:superadmin',
    ],
    category: 'TEKNİK İŞLEMLER',
  },

  {
    title: 'Anket Sayfası',
    path: '/dashboard/create-form',
    icon: icon('mdi:clipboard-list-outline'),
    permissions: [
      'mall-logistics:manager:highadmin',
      'mall-logistics:manager:superadmin',
      'mall-logistics:operations:highadmin',
      'mall-logistics:operations:superadmin',
    ],
    category: 'TEKNİK İŞLEMLER',
  },

  // {
  //   title: 'Eğitim',
  //   path: '/dashboard/tutorials',
  //   icon: icon('mdi:cast-tutorial'),
  //   permissions: [
  //     'mall:manager:mall-administration',
  //     'mall-logistics:manager:superadmin',
  //     'mall-logistics:accounting:accountant:',
  //     'mall-logistics:operations:highadmin',
  //     'mall-logistics:operations:porter',
  //     'mall-logistics:manager:highadmin',
  //     'mall-logistics:manager:porter',
  //     'mall-logistics:operations:admin',
  //     'store:manager:corporational',
  //     'store:manageroperations:corporational',
  //     'store:operations:corporational',
  //     'store:technical-support-staff:corporational',
  //     'store:technical-support-manager:corporational',
  //     'mall-logistics:manageroperations:highadmin',
  //     'mall-logistics:operations:muhaberat',
  //     'mall-logistics:mall-management:user',
  //     'mall-logistics:exceptional:user',
  //   ],
  //   category: 'TEKNİK İŞLEMLER',
  // },
  {
    title: 'Mağaza Eğitimi',
    path: '/dashboard/store-tutorial',
    icon: icon('mdi:cast-tutorial'),
    permissions: [
      'mall:manager:mall-administration',
      'mall-logistics:manager:superadmin',
      'mall-logistics:operations:highadmin',
      'mall-logistics:manager:highadmin',
      'mall-logistics:operations:admin',
      'mall-logistics:regional-manager:admin',
      'store:manager:corporational',
      'store:manageroperations:corporational',
      'store:operations:corporational',
      'store:technical-support-staff:corporational',
      'store:technical-support-manager:corporational',
      'mall-logistics:technical-support-staff:admin',
      'mall-logistics:technical-support-manager:admin',
      'mall-logistics:technical-support-staff:highadmin',
      'mall-logistics:technical-support-manager:highadmin',
      'mall-logistics:manageroperations:highadmin',
      'mall-logistics:exceptional:user',
    ],
    category: 'Eğitim Bölümü',
  },
  {
    title: 'Porter Eğitimi',
    path: '/dashboard/porter-tutorial',
    icon: icon('mdi:cast-tutorial'),
    permissions: [
      'mall:manager:mall-administration',
      'mall-logistics:manager:superadmin',
      'mall-logistics:accounting:accountant:',
      'mall-logistics:operations:highadmin',
      'mall-logistics:operations:porter',
      'mall-logistics:manager:highadmin',
      'mall-logistics:manager:porter',
      'mall-logistics:operations:admin',
      'mall-logistics:regional-manager:admin',
      'mall-logistics:manageroperations:highadmin',
      'mall-logistics:operations:muhaberat',
      'mall-logistics:exceptional:user',
    ],
    category: 'Eğitim Bölümü',
  },
  {
    title: 'AVM Yönetimi Hizmet Tanıtım Videoları',
    path: '/dashboard/mall-management-tutorial',
    icon: icon('mdi:cast-tutorial'),
    permissions: [
      'mall-logistics:mall-management-showcase:user',
      'mall-logistics:mall-management:user',
      'mall-logistics:manager:superadmin',
      'mall-logistics:mall-management:admin',
    ],
    category: 'Eğitim Bölümü',
  },
  {
    title: 'Sıkça Sorulan Sorular (SSS)',
    path: '/dashboard/faq',
    icon: icon('wpf:faq'),
    permissions: [
      'mall:manager:mall-administration',
      'mall-logistics:manager:superadmin',
      'mall-logistics:accounting:accountant:',
      'mall-logistics:operations:highadmin',
      'mall-logistics:operations:porter',
      'mall-logistics:manager:highadmin',
      'mall-logistics:manager:porter',
      'store:manager:corporational',
      'store:manageroperations:corporational',
      'store:operations:corporational',
      'store:technical-support-staff:corporational',
      'store:technical-support-manager:corporational',
      'mall-logistics:technical-support-staff:admin',
      'mall-logistics:technical-support-manager:admin',
      'mall-logistics:technical-support-staff:highadmin',
      'mall-logistics:technical-support-manager:highadmin',
      'mall-logistics:operations:admin',
      'mall-logistics:regional-manager:admin',
      'mall-logistics:manageroperations:highadmin',
      'mall-logistics:operations:muhaberat',
      //'mall-logistics:mall-management:user',
      'mall-logistics:exceptional:user',
    ],
    category: 'Eğitim Bölümü',
  },
  {
    title: 'Sıkça Sorulan Sorular Yönetimi',
    path: '/dashboard/faq-management',
    icon: icon('wpf:faq'),
    permissions: [
      'mall-logistics:manager:superadmin',
      'mall-logistics:operations:highadmin',
      'mall-logistics:manager:highadmin',
      'mall-logistics:manageroperations:highadmin',
      'mall-logistics:technical-support-staff:admin',
      'mall-logistics:technical-support-manager:admin',
      'mall-logistics:technical-support-staff:highadmin',
      'mall-logistics:technical-support-manager:highadmin',
    ],
    category: 'Eğitim Bölümü',
  },
];

export default navConfig;
